/**
 * Single icon source for the whole app (spec §2: one cohesive icon family,
 * no emoji). Re-exports the Lucide icons we use plus a couple of hand-made
 * marks for the tier yes/no table.
 */
export {
  ArrowLeft,
  ArrowRight,
  Bell,
  Calendar,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Clapperboard,
  Clock,
  Film,
  Gamepad2,
  Globe,
  Home,
  Info,
  ListVideo,
  Loader2,
  Lock,
  LogIn,
  LogOut,
  Mail,
  Menu,
  Minus,
  Play,
  Plus,
  Search,
  Settings,
  Shield,
  ShoppingBag,
  ShoppingCart,
  Sparkles,
  Tv,
  User,
  X,
} from 'lucide-react';

type MarkProps = {
  size?: number;
  className?: string;
};

/** Custom "yes" mark for the tier table — never an emoji. */
export function CheckMark({ size = 20, className }: MarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <circle cx="12" cy="12" r="11" className="fill-success/15" />
      <path
        d="m7.5 12.5 3 3 6-6.5"
        className="stroke-success"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Custom "no" mark for the tier table — never an emoji. */
export function CrossMark({ size = 20, className }: MarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <circle cx="12" cy="12" r="11" className="fill-ink-faint/10" />
      <path
        d="m8.5 8.5 7 7m0-7-7 7"
        className="stroke-ink-faint"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
